import { render } from "./collections.vue?vue&type=template&id=35b083b7&scoped=true"
import script from "./collections.vue?vue&type=script&lang=js"
export * from "./collections.vue?vue&type=script&lang=js"

import "./collections.vue?vue&type=style&index=0&id=35b083b7&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b083b7"]])

export default __exports__